import React from 'react';
import { Modal } from 'antd';

const QRCodeModal = props => {
    const { title, visible, onClose, qrCode } = props;

    return (
        <Modal
            title={title}
            className='text-center'
            visible={visible}
            footer={[]}
            onCancel={onClose}
        >
            <img src={qrCode} />
        </Modal>
    )
}

export default QRCodeModal;